import { CINE0226CintCollGroupId } from "respondent_config_generator/src/projects/CINE-0226";
import { PlatformInstructionsKey } from "../../LandingPage/Components/Steps/LoginAndCompletionCode";
import { LandingPageConfigBuilder } from "../../LandingPage/landingPageConfigBuilder";
import { CAIParams } from "../../queryParams";
import { setCurrentLang } from "../../i18n";
import { AppLanguage, getLanguageStrings } from "internationalisation";

const getPlatform = (groupId: CINE0226CintCollGroupId): PlatformInstructionsKey => {
	switch (groupId) {
		case "CINE-463-0226-CA-YAHOO":
			return "yahoo";
		case "CINE-464-0226-CA-FACEBOOK":
			return "facebook";
		default:
			assertNever(groupId);
	}
}

export const configureCINE0226Page = (
	landingPagebuilder: LandingPageConfigBuilder,
	params: CAIParams<CINE0226CintCollGroupId>
) => {
	setCurrentLang(AppLanguage.en);

	landingPagebuilder.setSteps(
		LandingPageConfigBuilder.getStandardViewingSurveySteps(
			getPlatform(params.G)
		)
	);

	landingPagebuilder.setPageTitle(
		getLanguageStrings(AppLanguage.en).LandingPage.Title
	);
}
